$( document ).ready(function() {
    


    var checkpathname = window.location.pathname;
    if(checkpathname == '/account/login'){
      if (window.location.search.length < 1){
        var url_after_login      = 'https://minuman.com/account/';
            $('[action="/account/login"]').append('<input type="hidden" name="checkout_url" value="'+url_after_login+'">');
      } 
    }else{
      var url_after_login      = window.location.href;
          $('[action="/account/login"]').append('<input type="hidden" name="checkout_url" value="'+url_after_login+'">');

    }
    $('body').on('mouseenter', function(){

    var data_url = $('a[href="/pages/brands"]').parent().find('.mega-menu .mega-menu__column').attr('data-url');
    if(data_url !== undefined){
     $.ajax({
    url: data_url,
    success: function(data) {
        data=$(data).find('.special-data-ajax-brands').html();
        $('a[href="/pages/brands"]').parent().find('.mega-menu__inner.mega-menu__inner--center.mega-menu__inner--large').html(data);
     }
    });
      
     $.ajax({
    url: 'https://minuman.com/search/?view=brandsmobile',
    success: function(data2) {
        data2=$(data2).find('.special-data-brands-mobile').html();
        $('body').find('.mobile-menu__inner .special-search-header-brand-data ul').append(data2);
     }
    });
      
    }

        
    });
    

    $('.BundleID').on('click', function(){
      var get_bundle = $(this).attr('data-bundle');
      var arrayRemove = [];
      $('.line-item[data-bundle="'+ get_bundle +'"]').each(function( index ) {
           var getID = $(this).attr('data-id');
           arrayRemove.push( $(this).attr("data-id") );
      });

      console.log('arrayRemove', arrayRemove);

      removeItems(arrayRemove);
   
      
      
    });
    

    function removeItems(items) {
      var itemsProcessed = items;
      var itemsArray = items;
      var qty = 0;
      var data = { updates: {} };
     
      for (i = 0; i < itemsArray.length; i++) {
         data.updates[itemsArray[i]] = qty;
      }
    
      jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function() { 
          location.reload();
        }
      });
    
    }
  
    window.goBack = function (e){
    var defaultLocation = "https://minuman.com/";
    var oldHash = window.location.hash;

    history.back(); // Try to go back

    var newHash = window.location.hash;

    /* If the previous page hasn't been loaded in a given time (in this case
    * 1000ms) the user is redirected to the default location given above.
    * This enables you to redirect the user to another page.
    *
    * However, you should check whether there was a referrer to the current
    * site. This is a good indicator for a previous entry in the history
    * session.
    *
    * Also you should check whether the old location differs only in the hash,
    * e.g. /index.html#top --> /index.html# shouldn't redirect to the default
    * location.
    */

    if(
        newHash === oldHash &&
        (typeof(document.referrer) !== "string" || document.referrer  === "")
    ){
        window.setTimeout(function(){
            // redirect to default location
            window.location.href = defaultLocation;
        },1000); // set timeout in ms
    }
    if(e){
        if(e.preventDefault)
            e.preventDefault();
        if(e.preventPropagation)
            e.preventPropagation();
    }
    return false; // stop event propagation and browser default event
}
  
    setTimeout(function(){ 
    jQuery('.animation-loader-wrapper').fadeOut(500);
 }, 1500);
  
  
    jQuery('.marge_same_section').each(function(index){
    if(index < 1) {
        jQuery(this).addClass('exp_expatify-grids-images1');
    }
    if(index > 0) {
        var data_marge = jQuery(this).find('.block-list').html();
         
        jQuery('body').find('.exp_expatify-grids-images1 .block-list').append(data_marge);
        jQuery(this).remove();
        
    }
});
  
  if ($(window).width() < 768) {
    jQuery('button.collection__layout-button[data-layout-mode="grid"]').click();
  }
  else {
    jQuery('button.collection__layout-button[data-layout-mode="grid"]').click();
  }

  jQuery('body').on('keyup', '.special-search-header-brand', function(){
    var this_value = jQuery(this).val();

    if (this_value.length > 0) {
      var res = this_value.toLowerCase();
      jQuery('.special-search-header-brand-data .mega-menu__item').hide();
      jQuery('.special-search-header-brand-data .mega-menu__item a:contains('+res+')').parent('li').show();
    }else {
      jQuery('.special-search-header-brand-data .mega-menu__item').show();
    }
  });

  jQuery('body').on('click','.special-top-cart-layout-button button', function(){
    var get_id = jQuery(this).attr('data-id');
    console.log(get_id);
    jQuery('body').find('#'+get_id).click();
  });

  /* ============================================================
     PDP Member Price Styling (client-side fallback)
     Reads config from Liquid-rendered JSON and applies correct
     price display matching Liquid server-side rendering.
     ============================================================ */
  (function() {
    var configEl = document.querySelector('[data-pdp-member-price-config]');
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch(e) {
      console.warn('[MemberPrice] Could not parse config', e);
      return;
    }

    if (!config.memberPrice || config.memberPrice === null) return;

    var priceList = document.querySelector('.price-list[data-member-price]');
    if (!priceList) return;

    // Skip if already styled with member pricing (red pill present)
    if (priceList.querySelector('[data-member-styled]')) return;

    var memberPriceCents = parseFloat(config.memberPrice) * 100;
    var variantPrice = config.variantPrice;
    var isLoggedIn = config.isLoggedIn;
    var productAvailable = config.productAvailable;

    // Read compare_at_price from existing Liquid-rendered price elements
    // We need to get variant data from the product JSON
    var productJsonEl = document.querySelector('[data-product-json]');
    var compareAtPrice = null;
    var currentPrice = variantPrice;
    if (productJsonEl) {
      try {
        var productJson = JSON.parse(productJsonEl.textContent);
        var selectedVariantId = productJson.selected_variant_id;
        var variants = productJson.product.variants;
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].id === selectedVariantId) {
            compareAtPrice = variants[i].compare_at_price;
            currentPrice = variants[i].price;
            break;
          }
        }
      } catch(e) { /* ignore */ }
    }

    var hasCompareAt = compareAtPrice && compareAtPrice > currentPrice;

    // Determine relationship between non-member price and compare-at-price
    var nonMemberHigherThanCompare = false;
    var nonMemberEqualsCompare = false;
    if (hasCompareAt) {
      if (memberPriceCents > compareAtPrice) {
        nonMemberHigherThanCompare = true;
      }
      if (memberPriceCents === compareAtPrice) {
        nonMemberEqualsCompare = true;
      }
    }

    // Use theme's currency format
    var currencyFormat = window.theme && window.theme.moneyFormat
      ? window.theme.moneyFormat
      : 'IDR ';

    // Helper: format money using theme's Currency utility or simple fallback
    function formatPrice(cents) {
      if (typeof Currency !== 'undefined' && Currency.formatMoney) {
        return Currency.formatMoney(cents, currencyFormat);
      }
      // Simple fallback for IDR
      var amount = Math.round(cents / 100);
      return 'IDR ' + amount.toLocaleString('id-ID');
    }

    var html = '';

    if (nonMemberHigherThanCompare && !nonMemberEqualsCompare && productAvailable) {
      // CASE 1: non_member > compare_at_price
      if (!isLoggedIn) {
        // Guest: strikethrough non-member + green compare-at
        html = '<span class="price price--compare pdp-price-compare-custom">' +
          '<span class="visually-hidden">Regular price</span>' +
          '<span class="special-money_without_currency">' + formatPrice(memberPriceCents) + '</span></span>' +
          '<span class="price price--highlight pdp-price-highlight-custom">' +
          '<span class="visually-hidden">Sale price</span>' +
          '<span class="special-money_without_currency">' + formatPrice(compareAtPrice) + '</span></span>';
      } else {
        // Logged-in: strikethrough non-member + red member price M+
        html = '<span class="price price--compare pdp-price-compare-custom">' +
          '<span class="visually-hidden">Regular price</span>' +
          '<span class="special-money_without_currency">' + formatPrice(memberPriceCents) + '</span></span>' +
          '<span class="price price--highlight">' +
          '<span class="visually-hidden">Sale price</span>' +
          '<span class="special-money_without_currency" data-member-styled="true" ' +
          'style="background: #D32F2F;color: #fff;border-radius: 40px;padding: 6px 10px;' +
          'display: inline-flex;align-items: center;gap: 8px;font-weight: 600;">' +
          formatPrice(currentPrice) +
          '<span style="border-radius: 40px; background: #a12020; padding: 4px 6px; font-size: 0.85em;">M+</span>' +
          '</span></span>';
      }
    } else if (nonMemberEqualsCompare && productAvailable) {
      // CASE 2: non_member == compare_at_price
      if (!isLoggedIn) {
        // Guest: just show non-member price, no strikethrough, no green
        html = '<span class="price">' +
          '<span class="visually-hidden">Sale price</span>' +
          '<span class="special-money_without_currency">' + formatPrice(memberPriceCents) + '</span></span>';
      } else {
        // Logged-in: strikethrough non-member + red member price M+
        html = '<span class="price price--compare pdp-price-compare-custom">' +
          '<span class="visually-hidden">Regular price</span>' +
          '<span class="special-money_without_currency">' + formatPrice(memberPriceCents) + '</span></span>' +
          '<span class="price price--highlight">' +
          '<span class="visually-hidden">Sale price</span>' +
          '<span class="special-money_without_currency" data-member-styled="true" ' +
          'style="background: #D32F2F;color: #fff;border-radius: 40px;padding: 6px 10px;' +
          'display: inline-flex;align-items: center;gap: 8px;font-weight: 600;">' +
          formatPrice(currentPrice) +
          '<span style="border-radius: 40px; background: #a12020; padding: 4px 6px; font-size: 0.85em;">M+</span>' +
          '</span></span>';
      }
    } else if (isLoggedIn) {
      // CASE 3: Logged-in member (standard)
      html = '<span class="price price--compare pdp-price-compare-custom">' +
        '<span class="visually-hidden">Regular price</span>' +
        '<span class="special-money_without_currency">' + formatPrice(memberPriceCents) + '</span></span>' +
        '<span class="price price--highlight">' +
        '<span class="visually-hidden">Sale price</span>' +
        '<span class="special-money_without_currency" data-member-styled="true" ' +
        'style="background: #D32F2F;color: #fff;border-radius: 40px;padding: 6px 10px;' +
        'display: inline-flex;align-items: center;gap: 8px;font-weight: 600;">' +
        formatPrice(currentPrice) +
        '<span style="border-radius: 40px; background: #a12020; padding: 4px 6px; font-size: 0.85em;">M+</span>' +
        '</span></span>';
    } else if (hasCompareAt) {
      // CASE 4: Guest with member price AND compare-at (non_member NOT higher/equal)
      // Show strikethrough non-member + green compare-at
      html = '<span class="price price--compare pdp-price-compare-custom">' +
        '<span class="visually-hidden">Regular price</span>' +
        '<span class="special-money_without_currency">' + formatPrice(memberPriceCents) + '</span></span>' +
        '<span class="price price--highlight pdp-price-highlight-custom">' +
        '<span class="visually-hidden">Sale price</span>' +
        '<span class="special-money_without_currency">' + formatPrice(compareAtPrice) + '</span></span>';
    } else {
      // CASE 5: Guest with member price, no compare-at — just show member price
      html = '<span class="price">' +
        '<span class="visually-hidden">Sale price</span>' +
        '<span class="special-money_without_currency">' + formatPrice(memberPriceCents) + '</span></span>';
    }

    priceList.innerHTML = html;

    console.log('[MemberPrice] PDP styling applied. LoggedIn:', isLoggedIn, 'MemberPrice:', config.memberPrice, 'VariantPrice:', variantPrice, 'CompareAt:', compareAtPrice, 'nonMemberHigher:', nonMemberHigherThanCompare, 'nonMemberEquals:', nonMemberEqualsCompare);
  })();

});